import { render, staticRenderFns } from "./AcceptTermsModal.vue?vue&type=template&id=96eb8098"
import script from "./AcceptTermsModal.vue?vue&type=script&lang=js"
export * from "./AcceptTermsModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptTermsModal.vue?vue&type=style&index=0&id=96eb8098&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports